import { atomWithReset } from 'jotai/utils';

import { EntryNotificationDrawer } from './types';

export const entryNotificationDrawerState = atomWithReset<EntryNotificationDrawer>({
  page: 1,
  perPage: 6,
  totalPage: 1,
  totalCount: 0,
});
